



window.onscroll = function() {myFunction()};

var atclocation = document.getElementById("atc-container2");
var stickypad = document.getElementById("sticky-pad");
var stickyprice = document.getElementById("sticky-price");
var sticky = atclocation.offsetTop;

function myFunction() {
  if (window.pageYOffset -"300" >= sticky) {
    atclocation.classList.add("sticky");
    stickypad.classList.add("sticky-pad");
     stickyprice.classList.add("sticky-price");
    
  } else {
    atclocation.classList.remove("sticky");
    stickypad.classList.remove("sticky-pad");
    stickyprice.classList.remove("sticky-price");
  }
}

